var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label-value',{attrs:{"label":_vm.$gettext('activities')}},[_c('activities',{staticClass:"is-size-3 has-text-secondary",attrs:{"activities":_vm.document.activities}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }